import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { postAccountMeters } from "services/ConfigServices";
import { dashboardTypeData, methodDataRessend } from "variables/lists/meters";
import { metersadminpagetext } from "variables/meters";
import 'moment/locale/fr';
import {
  CustomSelect,
  DateInput,
} from "components/Input/Index.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "2rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "2rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ReSendDataDialog(props) {
  const { closeModal, meters, energy, setOpenloading } = props;
  const [type, setType] = useState("");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'month').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [filtereddatachoicedata, setFiltereddatachoicedata] = useState([]);
  const [format, setFormat] = useState("raw");
  const [sendZero, setSendZero] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const classes = useStyles();

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleSendZeroChange = (event) => {
    setSendZero(!sendZero);
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const handleFormatChange = (event) => {
    setFormat(event.target.value);
  };
  const handleDatebeginChange = (event) => {
    let beginmax = moment();
    let newdatebegin = event.target.value;
    if (moment(newdatebegin).isAfter(beginmax))
      newdatebegin = beginmax.format("YYYY-MM-DD");
    if (moment(newdatebegin).isAfter(moment(dateend)))
      setDateend(newdatebegin);
    setDatebegin(newdatebegin);
  };
  const handleDateendChange = (event) => {
    let endmax = moment();
    let newdateend = event.target.value;
    if (moment(newdateend).isAfter(endmax))
      newdateend = endmax.format("YYYY-MM-DD");
    if (moment(newdateend).isBefore(moment(datebegin)))
      setDatebegin(newdateend);
    setDateend(newdateend);
  };

  useEffect(() => {
    if (type && datebegin && moment(datebegin).isValid() && dateend && moment(dateend).isValid())
      setButtonDisabled(false);
    else
      setButtonDisabled(true);
  }, [datebegin, dateend, type]);

  const handleSubmit = async (event) => {
    axios
      .post(
        postAccountMeters("resenddata", chartIdGroup, energy, datebegin, dateend, type, sendZero, format),
        {
          meters: meters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        setOpenloading(false);
        if (res.status == 200) {
          // if(res.data.success>0)
            setNotification("success", res.data.success + " succès");
          // else
          //   setNotification("warning", res.data.success + " succès");
          if(res.data.error>0)
          {
            setNotification("error", res.data.error + " erreurs");
            setNotification("error", res.data.errormessage);
          }
        }
        else
          setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setOpenloading(false);
        setNotification("error", "Une erreur est survenue");
      });
      setOpenloading(true);
      closeModal();
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else if (status === "warning") {
      NotificationManager.warn(text);
    }else {
      NotificationManager.error(text);
    }
  };

  useEffect(() => {
    if (energy) {
      let tmpdatachoicedata = dashboardTypeData[energy]
      setFiltereddatachoicedata(tmpdatachoicedata);
    }
  }, [energy]);

  return (
    <>
      <form className={classes.root}>
        {meters &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <CustomSelect
                  inputTitle={metersadminpagetext.type}
                  selectValue={type}
                  handleSelectValueChange={handleTypeChange}
                  data={filtereddatachoicedata}
                  isRequired={true}
                />
              </div>
            </GridItem>
            {(type === 'monthly') &&
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <CustomSelect
                    inputTitle={metersadminpagetext.format}
                    selectValue={format}
                    handleSelectValueChange={handleFormatChange}
                    data={methodDataRessend}
                    isRequired={true}
                  />
                </div>
              </GridItem>

            }
            {(type === 'monthly' && format === 'raw') &&
              <div>
                {metersadminpagetext.warningbillrecreate}
              </div>
            }

            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <DateInput
                  inputTitle={metersadminpagetext.datebegin}
                  dateInput={datebegin}
                  handleDateInputChange={handleDatebeginChange}
                  isRequired={true}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <div>
                <DateInput
                  inputTitle={metersadminpagetext.dateend}
                  dateInput={dateend}
                  handleDateInputChange={handleDateendChange}
                  isRequired={true}
                />
              </div>
            </GridItem>
            {!(type === 'monthly' && format === 'raw') &&
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <div>
                  <CustomSwitch
                    inputTitle={metersadminpagetext.sendzero}
                    checkedState={sendZero}
                    handleSwitchChange={handleSendZeroChange}
                  />
                </div>
              </GridItem>
            }
          </GridContainer>}
        <Button
          disabled={buttonDisabled}
          className={buttonDisabled ? classes.submitButtonDisabled : classes.submitButton}
          onClick={() => {
            handleSubmit();
          }}
        >
          Envoyer
        </Button>

      </form>
    </>
  );
}

export default ReSendDataDialog;
